define(['core/uploader',
        'core/logo-repository',
        'components/modal',
        'components/sidebar-flow',
        'components/preview-flow',
        'core/iterate',
        'core/browser-storage',
        'core/urls',
        'components/dropdown',
        'core/utilities',
        '@claviska/jquery-minicolors'],
    function (uploader, logo_repository, modal, sidebar, preview, iterate, storage, urls, DD, utilities) {

        var domainHintText = "We recommend you add your own company email domain in order to customize the <strong>From&nbsp;Name</strong> and <strong>From&nbsp;Address</strong> for your emails.";
        var surveyQuestionHintText = `We recommend using the default survey question to optimize your 
            survey results and the design of your survey email. You can also 
            get more info in our <a 
                href="https://docs.connectwise.com/SmileBack/030/020/040" 
                target="_blank" 
                class="sb-mail-link">
                Help Center
            </a>.`
        var subjectHintText = "You can personalize your subject line by adding <strong>[First&nbsp;Name]</strong> where you would like the recipient's name to appear."
        var greetingtHintText = "You can personalize your greeting by adding <strong>[First&nbsp;Name]</strong> where you would like the recipient's name to appear."
        var setUpStarted = false;
        var domainKey = "";
        var isDomain = false;
        var custom_domain_settings = {};
        var default_email_settings = {};
        var prev_email_setting = {};
        var uploadCare = null;
        var domainLink = null;
        var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        var customSwitch = null;

        var nodes = {
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    // document.querySelector(".nps-s1-setup-campaign"),
                    // document.querySelector(".navigation-main"),
                    // document.querySelector(".navigation-top")
                ]
            },
            getLogosContainer: function () {
                return document.querySelector(".modal-template-upload_js .logos_js")
            },
            exitSuccessSidebar: document.querySelector(".return-success_js"),
            formAddressWrap: document.querySelector("#div_id_from_address"),
            formDomainWrap: document.querySelector("#div_id_domain"),
            formSubjectWrap: document.querySelector("#div_id_subject"),
            formGreetingWrap: document.querySelector("#div_id_greeting"),
            formQuestionWrap: document.querySelector("#div_id_question"),
            formNameWrap: document.querySelector("#div_id_from_name"),
            selectedImg: document.querySelector("[name=\"selected-logo\"]"),
            nameInput: document.querySelector("[name=\"from_name\"]"),
            addressInput: document.querySelector("[name=\"from_address\"]"),
            imgPreview: {
                withLogo: document.querySelector(".conf-mail-withlogo_js"),
                noLogo: document.querySelector(".conf-mail-nologo_js"),
                controls: document.querySelector(".conf-mail-upload-ctrl_js"),
                openBtn: document.querySelector(".uploader-open_js"),
                minusLogo: document.querySelector(".uploader-delete-logo_js")
            },
            modalContent: document.querySelector('.modal-template-upload_js'),
            modalPreview: document.querySelector(".modal-template-application-preview_js"),
            logoPicker: document.querySelector(".logo-picker_js"),
            previewBtn: document.querySelector(".preview-btn_js"),
            progress: document.querySelector(".new-progress"),
            modalLogosClass: ".logos_js",
            sideBarSteps: {
                wrap: document.querySelector(".sidebar_js"),
                closeSideBar: document.querySelectorAll(".close-sidebar_js"),
                menuSteps: document.querySelectorAll(".sidebar-menu-step_js"),
                contentSteps: document.querySelectorAll(".dns-sb-step_js"),
                sendDomainBtn: document.querySelector(".send-domain_js"),
                setUpDomainBtn: document.querySelector(".set-up-domain_js"),
                domainInput: document.querySelector(".domain-input_js"),
                domainMessage: document.querySelector(".dns-domain-message_js"),
                copyBlocks: document.querySelectorAll(".copy_js"),
                copyText: document.querySelector(".copy_text_js")
            },
            previewModal: {
                wrapper: document.querySelector(".preview_js"),
                closeButton: document.querySelector(".preview-close_js"),
                continueButton: document.querySelector(".preview-continue_js"),
                steps: document.querySelector(".preview-steps_js"),
                content: document.querySelector(".preview-content_js"),
                navigation: document.querySelector(".preview-nav_js"),
            },
            tryAgainBtn: document.querySelector(".try_again_js"),
            verifyDNSBtn: document.querySelector(".verify_dns_js"),
            errorNode:document.querySelector(".sb-sidebar__step-2-1 .verification-error"),
            switchDomain: document.querySelector("[name='domain']"),
            copyNodes: document.querySelectorAll(".sb-sidebar .copy-wrap"),
            getUploadCareBtn: function () {
                return document.querySelector(".upload-care_js")
            }
        };

        let formInputs = document.querySelector("form").querySelectorAll("input, textarea");
        let newDomainID = "";
        let createdModal = modal.create(nodes.modal, function (el) {});

        // steps to pass into preview component
        let previewConfig = {
            nextPage: urls["nps:configure-feedback"](),
            steps: [
                    {
                        title: "Email Preview",
                        url: urls["nps:configure-email"](),
                        method: "POST"
                    }
                ]
            };

        let previewModal = preview.create(nodes.previewModal, previewConfig)

        function grayScaleInputs(isDomain) {
            if (isDomain) {
                nodes.nameInput.classList.remove("disabled");
                nodes.addressInput.classList.remove("disabled");
            } else {
                nodes.nameInput.classList.add("disabled");
                nodes.addressInput.classList.add("disabled");
            }
        }

        var dnsSideBar = sidebar.create(nodes.sideBarSteps,null,(step,subStep)=>{
            nodes.copyNodes.forEach(button => {
                button.addEventListener("click", () => {
                    let parent = button.parentElement;
                    let value = parent.querySelector("input").value;
    
                    navigator.clipboard.writeText(value).then(() => {
                        button.innerText = "Copied!"
                        button.classList.add("copied");
    
                        setTimeout(() => {
                            button.innerText = "Copy"
                            button.classList.remove("copied");
                        }, 3000)
                    });
                })
            })
        });


        var progress = (function () {
            let p = nodes.progress;
            p.classList.add("disabled");
            return {
                start: function () {
                    p.classList.remove("disabled");
                },
                stop: function () {
                    p.classList.add("disabled");
                }
            }
        })();

        progress.start();

        var imageWorker = {
            set: function (img) {
                this.image = img
            },
            save: function () {
                storage.addObj("conf-email-img", this.image || {id: "", title: "", src: ""});
            },
            get: function () {
                return this.image
            },
            remove: function () {
                storage.removeItem("conf-email-img");
            }
        };

        function getErrorsAndShowMessage(names, params) {
            let errors = [];
            names.forEach(function (name) {
                let input = document.querySelector('[name="' + name + '"]');
                var message = input.parentNode.querySelector(".input-message");
                if (!params[name] || !params[name].trim().length) {
                    input.classList.add("danger");
                    let message = params.error ? params.error : "This field is required.";
                    input.insertAdjacentHTML('afterend', "<div class=\"input-message\">" + message + "</div>");
                    message = input.parentNode.querySelector(".input-message");
                    message.classList.add("active");
                    errors.push({name: name, input: input});
                    input.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                } else {
                    if (message)
                        message.classList.remove("active");
                    input.classList.remove("danger");
                }
            });
            return errors;
        }

        function addCharacterCount(input, limit) {
            let currentLength = input.value.length;
            input.insertAdjacentHTML('afterend', `<div class="char-count"><span class="current">${currentLength}</span> / ${limit}</div>`);
            let limitMet = false;

            let execution = (event) => {
                currentLength = event.target.value.length;
                let countEl =  input.parentNode.querySelector(".char-count");
                let countSpan = countEl.querySelector(".current");
                
                countSpan.innerText = currentLength;

                if(currentLength > limit) {
                    countEl.classList.add("error");
                    input.classList.add("danger");
                    limitMet = true;
                    return;
                }

                if(limitMet && currentLength <= limit) {
                    countEl.classList.remove("error");
                    input.classList.add("danger");
                    limitMet = false;
                }
            }

            input.addEventListener("keyup", execution);
            input.addEventListener("click", execution);
            
        }

        let setDefaultColor = () => {
            let input = document.querySelector("#id_color");
            let defaultColor = input.getAttribute("data-default");
            document.querySelector(".minicolors-swatch-color").style = `background-color: ${defaultColor};`;
            input.value = defaultColor
        }

        function addInputReset(input) {
            input.insertAdjacentHTML("beforebegin", '<img class="reset-input" src="/static/icons/refresh.svg" alt="">')
            let resetButton = input.parentNode.querySelector(".reset-input");

            resetButton.addEventListener("click", (e) => {
                let defaultString = input.getAttribute("data-default");
                let companyName = document.querySelector("#id_company").value;
                input.value = defaultString.replace("{}", companyName);

                currentLength = input.value.length;
                let countEl =  input.parentNode.querySelector(".char-count");
                if(countEl) {
                    let countSpan = countEl.querySelector(".current");
                    countSpan.innerText = currentLength;
                }

                if(input.name === 'color') {
                    setDefaultColor();
                }

                e.target.classList.add("roll");
                setTimeout(()=>{
                    e.target.classList.remove("roll")
                },300)
            })
        }

        let questionInput = document.querySelector("textarea[name='question']");
        addCharacterCount(questionInput, 140);
        addInputReset(questionInput);

        let subjectInput = document.querySelector("input[name='subject']");
        addCharacterCount(subjectInput, 60);
        addInputReset(subjectInput);

        let greetingInput = document.querySelector("input[name='greeting']");
        addCharacterCount(greetingInput, 60);
        addInputReset(greetingInput);

        let brandColor = document.querySelector("input[name='color']");
        addInputReset(brandColor);


        function sendDomain(domainName, cb) {
            fetch(`${urls["configuration:add-domain"]()}?domain=${domainName}`, {
                method: "GET",
            })
            .then(response => {
                if(response.status !== 200) {
                    cb(false);
                    nodes.sideBarSteps.sendDomainBtn.classList.remove("loading");
                    nodes.sideBarSteps.domainMessage.classList.add("active");
                    return null;
                }
                return response.json()
            })
            .then((json) => {
                if(json) {
                    domainData = json;
                    newDomainID = json.id;
                    cb(json)
                }
            });
        }

        function validateDomain(cb) {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', urls["configuration:validate-domain"](newDomainID), true);
            xhr.send();

            xhr.onload = function () {
                if (xhr.status != 200) {
                    cb(false);
                } else {
                    const resp = JSON.parse(xhr.responseText);
                    cb(resp);
                }
            };
        }

        function removeErrors(input) {
            input.classList.remove("danger");
            let message = input.nextSibling;
            if (message.classList) {
                let isMessage = false;
                iterate(message.classList, function (className) {
                    if (className == "input-message") {
                        isMessage = true;
                    }
                });
                if (isMessage) {
                    input.parentNode.removeChild(message);
                }
            }
        }

        function addImgToList(wrap, imageData) {

            let div = document.createElement("div");
            div.style.backgroundImage = "url('" + imageData.src + "')";

            ['id', "title", "src"].forEach(function (key) {
                div.setAttribute("data-" + key, imageData[key]);
            });

            div.classList.add("sb-modal-upload__select-item");
            div.classList.add("logo-item_js");

            div.setAttribute("alt", imageData.title);
            wrap.prepend(div);

        }

        function waitImg(src, onLoaded) {
            var preloaderImg = document.createElement("img");
            preloaderImg.src = src;
            preloaderImg.addEventListener('load', (event) => {
                preloaderImg = null;
                onLoaded();
            });
        }

        function addImgToPreview(imageContainer, img) {
            setImgId(img.id);
            imageContainer.withLogo.style.backgroundImage = 'url(' + img.src + ')';
            imageContainer.withLogo.setAttribute('alt', img.name);
            ['id', "uuid"].forEach(function (key) {
                imageContainer.withLogo.setAttribute('data' + key, img[key]);
            });
        }

        function setImgId(id) {
            document.querySelector("#id_logo_id").value = id;
        }

        function removeImgId() {
            document.querySelector("#id_logo_id").value = "";
            imageWorker.remove();
        }

        function showPreview(nodes) {
            nodes.controls.classList.remove("disabled");
            nodes.noLogo.classList.add("disabled");
            nodes.withLogo.classList.remove("disabled");
        }

        function hidePreview(nodes) {
            removeImgId();
            nodes.controls.classList.add("disabled");
            nodes.noLogo.classList.remove("disabled");
            nodes.withLogo.classList.add("disabled");
        }

        function openUploadModal() {
            createdModal.open(null, function (el) {

                let btn = el.querySelector(".upload-care_js");

                btn.addEventListener("click", function () {

                    var dialog = uploadCare.openDialog(null, {
                        validators: [
                            uploader.maxSizeValidator(window.UPLOADCARE_FILE_MAX_MB * 1024 * 1024),
                            uploader.fileTypeValidator('png jpeg jpg gif')
                        ]
                    });

                    dialog.done(function imageUploaded(result) {

                        createdModal.close();
                        progress.start();

                        result.done(function (fileInfo) {

                            logo_repository
                                .LogoRepository
                                .save(fileInfo.uuid)
                                .done(function (logo) {

                                    let img = {
                                        title: logo.title,
                                        id: logo.id,
                                        src: logo.resource_thumbnail,
                                    };

                                    imageWorker.set(img);

                                    addImgToList(nodes.getLogosContainer(), img);

                                    addImgToPreview(nodes.imgPreview, img);

                                    waitImg(logo.resource_thumbnail, function () {

                                        showPreview(nodes.imgPreview);
                                        progress.stop();

                                    })

                                });

                        });

                    }).fail(function () {
                        nodes.imgPreview.noLogo.classList.remove("disabled");
                        progress.stop();
                    });

                });

                var logosWrapper = el.querySelector(nodes.modalLogosClass);

                function onLogoClick(e) {

                    var image = {};
                    var target = e.target;
                    var id = target.getAttribute("data-id");

                    if (!id) {
                        return
                    }

                    image.id = id;
                    image.src = target.getAttribute("data-src");
                    image.title = target.getAttribute("data-title");

                    addImgToPreview(nodes.imgPreview, image);

                    imageWorker.set(image);

                    showPreview(nodes.imgPreview);

                    createdModal.close(function () {
                        logosWrapper.removeEventListener("click", onLogoClick);
                    });

                }

                let showMoreButton = el.querySelector(".show-more_js");
                function showAllLogos() {
                    let hiddenLogos = el.querySelectorAll(".logo-item_js.hide-mobile");
                    hiddenLogos.forEach(logo => {
                        logo.classList.remove("hide-mobile");
                    });
                    showMoreButton.innerText = "Close"
                    showMoreButton.removeEventListener("click", showAllLogos);
                    showMoreButton.addEventListener("click", () => createdModal.close());
                }

                logosWrapper.addEventListener("click", onLogoClick);
                el.querySelector(".modal-close_js").addEventListener("click", () => {
                    createdModal.close();
                });
                showMoreButton.addEventListener("click", showAllLogos);

            }, nodes.modalContent)

        }

        function createDomainLink(after, className) {
            var link = document.createElement("div");
            link.classList.add(className);
            after.parentNode.insertBefore(link, after.nextSibling);
            return {
                changeText(text) {
                    link.innerText = text;
                },
                node: link
            }
        }

        let hrefs = document.querySelectorAll("a[href]");
        let closeSideBar = document.querySelector(".close-sidebar");
        let canClose = true;
        let closeModal = () => {
            dnsSideBar.switch(1, 2);
            dnsSideBar.close();
            removeExitDomainPrompt();
             createdModal.close();
        };
        closeSideBar.addEventListener("click", (e) => {
            e.preventDefault();
            if (canClose) {
                dnsSideBar.switch(1, 2);
                dnsSideBar.close();
            } else {
                let modalTemplate = document.querySelector(".modal-template-leave_js");
                modalTemplate.querySelector(".confirm-msg_js b").innerText = "Exit ‘Set up your domain’?";
                createdModal.open(null, function (el) {
                    const a = el.querySelector("a");
                    a.setAttribute("href", "#");
                    a.removeEventListener("click",closeModal);
                    a.addEventListener("click",closeModal);
                }, modalTemplate);
            }
        });

        let modalTemplate = document.querySelector(".modal-template-leave_js")

        let hrefsToIgnore = [
            urls['nps:campaign'](), 
            urls['nps:configure-email'](), 
            urls['nps:configure-feedback'](), 
            urls['nps:survey']()
        ] 
        
        // we need two separate event listeners for each exit modal (domain vs main email flow)
        // so we can remove the domain listener without removing the generic email flow listener
        let leaveDomainListener = function(event)  {
            let message = "Exit ‘Set up your domain’?"
            utilities.confirmPageExit(event, createdModal, modalTemplate, message);
        };

        let leaveEmailListener = function(event)  {
            let modalTemplate = document.querySelector(".modal-template-leave_js");
            let message = "Exit ‘Create Campaign’?";
            if (modalTemplate.getAttribute("data-update-flow") !== "None")
                message = "Exit ‘Manage Campaign’?";
            utilities.confirmPageExit(event, createdModal, modalTemplate, message, hrefsToIgnore);
        };

        function onExitDomainFlow() {
            canClose = false;
            iterate(hrefs, function (node) {
                node.addEventListener("click", leaveDomainListener);
            });
        }

        function removeExitDomainPrompt() {
            canClose = true;
            iterate(hrefs, function (node) {
                node.removeEventListener("click", leaveDomainListener);
            });
        }

        function onExitEmailFlow() {
            iterate(hrefs, function (node) {
                node.addEventListener("click", leaveEmailListener);
            });
        }

        function insertAtCursor(field, value) {
            //IE support
            if (document.selection) {
                field.focus();
                sel = document.selection.createRange();
                sel.text = value;
            }
            else if (field.selectionStart || field.selectionStart == '0') {
                var startPos = field.selectionStart;
                var endPos = field.selectionEnd;
                field.value = field.value.substring(0, startPos)
                    + value
                    + field.value.substring(endPos, field.value.length);
            } else {
                field.value += value;
            }

            field.click();
        }        

        function createTooltip(hintText, wrapper, className) {
            let hint = `<div class="icon"><img src="/static/icons/info.svg" alt=""></div>
                        <div class='sb-tooltip'>${hintText}</div>`;
            let div = document.createElement("div");
            div.classList.add("tooltip-wrap", className);
            div.innerHTML = hint;
            wrapper.appendChild(div);
        }

        function createNameInsert(element, message) {
            let div = document.createElement("div");
            div.classList.add("nps-plus-link");
            div.innerHTML = message;

            let input = element.querySelector("input");
            if(input.value.indexOf("[First Name]") > -1) {
                div.classList.add("disabled");
            }

            input.addEventListener("input", () => {
                if(input.value.indexOf("[First Name]") === -1) {
                    div.classList.remove("disabled");
                } else {
                    div.classList.add("disabled");
                }
            })

            div.addEventListener("click", () => {
                if(!div.classList.contains("disabled")) {
                    insertAtCursor(input, "[First Name]")
                    div.classList.add("disabled")
                }
            })

            element.querySelector(".input-wrapper").appendChild(div);
        }

        var modifyFirstTime = true;

        function formModifier(domainKey) {

            let formInputs = document.querySelector("form").querySelectorAll("input");

            iterate(formInputs, removeErrors);

            var addressInput = nodes.formAddressWrap.querySelector("input");
            var nameInput = nodes.formNameWrap.querySelector("input");
            var hint = nodes.formAddressWrap.querySelector(".nps-dns-hint");

            function noDomain() {
                document.querySelector("#div_id_from_address").classList.remove("custom-domain");
                
                if (isDomain) {
                    if (modifyFirstTime) {
                        prev_email_setting.from_name = custom_domain_settings.from_name;
                        prev_email_setting.from_address = custom_domain_settings.from_address;
                        modifyFirstTime = false;
                    } else {
                        prev_email_setting.from_name = custom_domain_settings.from_name === nameInput.value ? "" : nameInput.value;
                        prev_email_setting.from_address = custom_domain_settings.from_address === addressInput.value ? "" : addressInput.value;
                    }
                }

                addressInput.classList.add("default");

                nodes.formAddressWrap.classList.remove("sb-input-group_right-label");
                var rightLabel = nodes.formAddressWrap.querySelector(".sb-input-group__right-label");

                hint.classList.remove("disabled");

                addressInput.setAttribute("disabled", "disabled");
                addressInput.value = default_email_settings.from_address;

                if (!isDomain)
                    nodes.formDomainWrap.classList.add("disabled");

                nameInput.setAttribute("disabled", "disabled");
                nameInput.value = default_email_settings.from_name;
                rightLabel = document.querySelector(".sb-input-group__right-label");
                if (rightLabel) {
                    rightLabel.remove();
                }
            }

            function yesDomain() {
                document.querySelector("#div_id_from_address").classList.add("custom-domain");
                domainLink.changeText("Add domain");
                nodes.formAddressWrap.classList.add("sb-input-group_right-label");
                addressInput.removeAttribute("disabled");
                rightLabel = document.querySelector(".sb-input-group__right-label");
                addressInput.classList.remove("default");
                if (rightLabel) {
                    rightLabel.remove();
                }

                rightLabel = CreateElement(
                    "div",
                    "sb-input-group__right-label",
                    nodes.formAddressWrap,
                    "appendChild"
                );

                rightLabel.innerHTML = "@" + custom_domain_settings.domain;
                addressInput.value = prev_email_setting.from_address || custom_domain_settings.from_address || "";
                nodes.formDomainWrap.classList.remove("disabled");

                addressInput.setAttribute("placeholder", "Enter your email");
                nameInput.setAttribute("placeholder", "Enter your name");
                nameInput.removeAttribute("disabled");


                hint.classList.add("disabled");

                nameInput.value = prev_email_setting.from_name || custom_domain_settings.from_name || "";
            }

            if (domainKey === "0") {
                grayScaleInputs(false);
                noDomain();
            } else {
                grayScaleInputs(true) ;
                yesDomain();
            }


        }

        //magic
        function CreateElement(tag, className, parent, method) {

            var element = document.createElement(tag);

            element.classList.add(className);

            parent[method](element);

            element.update = function (modifier) {

                modifier(element, parent);

                return element;

            };

            return element;

        }

        function appendDomain(key) {
            let isDuplicate = false;
            let duplicateID = '';
            let existingDomains = document.querySelector(".domain-select .mock-options");
            existingDomains.querySelectorAll(".mock-option").forEach(domain => {
                if(domain.innerText.trim() === custom_domain_settings.domain.trim()) {
                    isDuplicate = true;
                    duplicateID = domain.dataset.value;
                }
            })

            if(!isDuplicate) {
                customSwitch.addOption(key, custom_domain_settings.domain);
            } else {
                customSwitch.chooseOption(duplicateID);
            }
        }

        function setColor(value) {
            $(".nps-color-picker .color-picker-preview").css('background-color', value);
            $("form input[name='color']").val(value);
        }

        return {
            init: function () {

                onExitEmailFlow();

                dnsSideBar.switch(1, 1, true);

                let default_email_settingsJSON = document
                    .querySelector("[data-default-values]")
                    .getAttribute("data-default-values");

                default_email_settings = JSON.parse(default_email_settingsJSON);

                domainLink = createDomainLink(
                    nodes.addressInput,
                    "nps-plus-link"
                );

                $('#id_color').minicolors($.minicolors.defaults);

                $(".reset-color_js").on("click", function (event) {
                    event.target.classList.add("roll");
                    setColor(defaultColor);
                    setTimeout(() => {
                        event.target.classList.remove("roll");
                    }, 300);
                });

                domainLink.node.addEventListener("click", function () {
                    if (!isDomain && !setUpStarted) {
                        dnsSideBar.switch(1, 1, true);
                    } else if (isDomain && !setUpStarted) {
                        dnsSideBar.switch(1, 2);
                        nodes.sideBarSteps.domainInput.value =  "";
                        toggleSendDomainBtn(nodes.sideBarSteps.domainInput.value); 
                        if (custom_domain_settings.domain) nodes.sideBarSteps.sendDomainBtn.removeAttribute("disabled");
                    } else {
                        dnsSideBar.switch(1, 2);
                    }

                    setUpStarted = true;
                    dnsSideBar.open();

                });

                let selected = nodes.switchDomain.querySelector("[selected]");
                let customSelectWrap = nodes.switchDomain.parentNode;
                customSelectWrap.removeAttribute("class");

                let customSelectIMG = document.createElement("img");
                let customSelectImgSrc = document.querySelector(".custom-domain-image").getAttribute("src");
                customSelectIMG.setAttribute("src", customSelectImgSrc);
                customSelectWrap.appendChild(customSelectIMG);
                customSelectWrap.classList.add("custom-select");
                customSelectWrap.classList.add("domain-select");
                customSelectWrap.querySelector('select').style.display = "none";

                customSwitch = DD(customSelectWrap,function (key) {
                    if (key !== "0") {
                        let selected = nodes.switchDomain.querySelector("[value='" + key + "']");
                        custom_domain_settings.domain = selected.innerHTML;
                    }
                    domainKey = key;
                    formModifier(key);
                });

                domainKey = selected ? selected.value : "0";
                isDomain = nodes.switchDomain.querySelectorAll("option").length > 1;

                grayScaleInputs(isDomain);
                if (isDomain) {
                    domainLink.changeText("Add domain");
                } else {
                    domainLink.changeText("Set up your domain");
                }

                if (isDomain && selected.value !== "0") {
                    custom_domain_settings.domain = selected.innerText;
                    custom_domain_settings.from_address = nodes.formAddressWrap.querySelector("input").value;
                    custom_domain_settings.from_name = nodes.formNameWrap.querySelector("input").value;
                }

                createTooltip(domainHintText, nodes.formAddressWrap, "nps-dns-hint"); 
                createTooltip(surveyQuestionHintText, nodes.formQuestionWrap);
                createTooltip(subjectHintText, nodes.formSubjectWrap);
                createTooltip(greetingtHintText, nodes.formGreetingWrap);

                createNameInsert(nodes.formSubjectWrap, "Add customer name to subject");
                createNameInsert(nodes.formGreetingWrap, "Add customer name to greeting");

                formModifier(domainKey);

                function toggleSendDomainBtn(val) {
                    val ? nodes.sideBarSteps.sendDomainBtn.classList.remove("disabled") : nodes.sideBarSteps.sendDomainBtn.classList.add("disabled");
                }

                uploader
                    .initializeAndWaitUntilReady(
                        function (uploadcare) {

                            toggleSendDomainBtn(nodes.sideBarSteps.domainInput.value.trim());

                            nodes.sideBarSteps.domainInput.addEventListener("input", function (e) {
                                var val = e.target.value.trim();
                                toggleSendDomainBtn(val);
                            });

                            nodes.tryAgainBtn.addEventListener("click", function (e) {
                                e.preventDefault();
                                removeExitDomainPrompt();
                                dnsSideBar.switch(1, 2);
                            });

                            nodes.exitSuccessSidebar.addEventListener("click",function() {
                                removeExitDomainPrompt();
                            });

                            var domainName = "";

                            nodes.sideBarSteps.setUpDomainBtn.addEventListener("click", function (e) {
                                e.preventDefault();

                                dnsSideBar.switch(1, 2);
                            });

                            nodes.sideBarSteps.sendDomainBtn.addEventListener("click", function (e) {

                                nodes.sideBarSteps.domainMessage.innerText = "Domain is not valid.";
                                nodes.sideBarSteps.sendDomainBtn.classList.add("loading");
                                nodes.sideBarSteps.domainMessage.classList.remove("active");
                                nodes.errorNode.classList.add("hide");

                                e.preventDefault();

                                domainName = nodes.sideBarSteps.domainInput.value.trim();

                                sendDomain(domainName, function (response) {
                                    nodes.sideBarSteps.sendDomainBtn.classList.remove("loading");
                                    if (response && !response.error) {
                                        onExitDomainFlow();
                                        
                                        dnsSideBar.switch(2, 1);

                                        nodes.sideBarSteps.domainMessage.classList.remove("active");

                                        document.querySelector(".domain-name-context span").innerText = domainName;

                                        iterate(response, function (val, key) {
                                            if(key !== "id") {
                                                iterate(val, function (v, k) {
                                                    document
                                                        .querySelector("[data-" + key + "-" + k + "]")
                                                        .setAttribute("value", v);
                                                })
                                            }
                                        });
                                    } else if (response && response.error) {
                                        let listClass = response.error.length > 1 ? "multiple-errors" : "";
                                        nodes.sideBarSteps.domainMessage.innerHTML = `
                                            <ul class="${listClass}">
                                                ${response.error.map(error => `<li>${error}</li>`).join('')}
                                            </ul>
                                            Please review your DNS settings. If you are unsure about the issue, you can use a webtool to perform an 
                                            SPF record lookup (such as <a target="_blank" href="https://mxtoolbox.com/">https://mxtoolbox.com/</a>). This can help with diagnostics.  
                                        `
                                        nodes.sideBarSteps.domainMessage.classList.add("active");
                                    }

                                    setUpStarted = false;
                                })
                            });

                            nodes.verifyDNSBtn.addEventListener("click", function (e) {
                                e.preventDefault();
                                nodes.verifyDNSBtn.classList.add("loading");
                                nodes.errorNode.classList.add("hide");

                                validateDomain((resp) => {
                                    if (resp.success) {      
                                        if(custom_domain_settings.domain) {
                                            custom_domain_settings.prevDomain = custom_domain_settings.domain;
                                        }
                                        isDomain = true;
                                        domainKey = newDomainID || "-1";
                                        custom_domain_settings.domain = domainName;
                                        formModifier(domainKey);
                                        appendDomain(domainKey);                
                                        dnsSideBar.switch(3, 1);
                                    } else {
                                        let errorMessage;
                
                                        if(resp.errors && resp.errors.length > 0) {
                                            errorMessage = `
                                                Your domain is invalid due to the following issues: 
                                                <ul>
                                                    ${resp.errors.map(error => `<li>${error}</li>`).join('')}
                                                </ul>
                                                Please review your DNS settings. If you are unsure about the issue, you can use a webtool to perform an 
                                                SPF record lookup (such as <a target="_blank" href="https://mxtoolbox.com/">https://mxtoolbox.com/</a>). This can help with diagnostics.                                
                                            `
                                        } else {
                                            errorMessage = `
                                                There is an issue with your domain settings. 
                                                Please make sure your SPF TXT Record contains a SmileBack reference 
                                                and your DKIM TXT Record matches above.
                                            `
                                        }
                                        nodes.errorNode.innerHTML = `
                                            ${errorMessage}
                                            <br><br>
                                            Please note: DNS verification is not always performed instantly. 
                                            Please wait a few minutes to try again or you can get more information 
                                            in our <a target="_blank" href="https://docs.connectwise.com/SmileBack/030/020/060">Help Center</a>.
                                        `;
                
                                        nodes.errorNode.classList.remove("hide");
                                    }
                
                                    nodes.verifyDNSBtn.classList.remove("loading");
                                });

                            });

                            nodes.logoPicker.addEventListener("dragover", function (e) {
                                nodes.logoPicker.classList.add("dragover");
                            });

                            nodes.logoPicker.addEventListener("click", function (e) {
                                openUploadModal();
                            });

                            nodes.logoPicker.addEventListener("dragleave", function (e) {
                                nodes.logoPicker.classList.remove("dragover");
                            });

                            uploadcare.dragdrop.uploadDrop(nodes.logoPicker, function (file) {

                                nodes.logoPicker.classList.remove("dragover");
                                progress.start();

                                file.done(function (params) {
                                    if (params.isImage) {
                                        logo_repository
                                        .LogoRepository
                                        .save(params.uuid)
                                        .done(function (logo) {

                                            var img = {
                                                title: logo.title,
                                                id: logo.id,
                                                src: logo.resource_thumbnail,
                                            };

                                            imageWorker.set(img);

                                            addImgToList(nodes.getLogosContainer(), img);
                                            addImgToPreview(nodes.imgPreview, img);

                                            waitImg(logo.resource_thumbnail, function () {

                                                showPreview(nodes.imgPreview);
                                                progress.stop();

                                            })

                                        });
                                    }

                                });

                            });

                            uploadCare = uploadcare;

                            let image = storage.getObj("conf-email-img");

                            function setImg(image) {
                                imageWorker.set(image);
                                addImgToPreview(nodes.imgPreview, image);
                                if (image.id)
                                    showPreview(nodes.imgPreview, image);
                            }

                            if (nodes.selectedImg) {
                                image = nodes.selectedImg.getAttribute("value");
                                image = JSON.parse(image);
                                setImg(image);
                            } else if (image) {

                                // setImg(image);

                            }

                            nodes.imgPreview.minusLogo.addEventListener("click", function () {
                                hidePreview(nodes.imgPreview);
                            });

                            nodes.previewBtn.addEventListener('click', function (e) {

                                e.preventDefault();
                                imageWorker.save();

                                let requestBody = [];
                                let params = {};

                                var e = encodeURIComponent;

                                var iterateResult = iterate(formInputs,
                                    function (input, key, obj, stop) {

                                        removeErrors(input);
                                        var name = input.getAttribute("name");
                                        var value = input.value;

                                        params[name] = value;

                                        if (!(name === "logo_id" && !value)) {
                                            if (name) requestBody.push(e(name) + '=' + e(value));
                                        } else {
                                            imageWorker.remove();
                                        }

                                    }
                                );

                                if (params.color.length !== 7) {
                                    getErrorsAndShowMessage(
                                        ["color"],
                                        {
                                            error: "Please enter a brand colour"
                                        });
                                    return;
                                }

                                // TO DO - change this and other references to new question field
                                if (params.question.length > 140) {
                                    getErrorsAndShowMessage(
                                        ["question"],
                                        {
                                            company: null,
                                            error: "Please limit to 140 characters"
                                        });
                                    return;
                                }

                                if (params.subject.length > 60) {
                                    getErrorsAndShowMessage(
                                        ["subject"],
                                        {
                                            company: null,
                                            error: "Please limit to 60 characters"
                                        });
                                    return;
                                }

                                if (params.greeting.length > 60) {
                                    getErrorsAndShowMessage(
                                        ["greeting"],
                                        {
                                            company: null,
                                            error: "Please limit to 60 characters"
                                        });
                                    return;
                                }

                                if (isDomain && domainKey !== "0") {                                    
                                    if (!emailRegExp.test(`${params["from_address"]}@${custom_domain_settings.domain}`)) {
                                        getErrorsAndShowMessage(
                                            ["from_address"],
                                            {
                                                company: null,
                                                error: "Email is invalid"
                                            });
                                        return;
                                    }
                                }

                                if (iterateResult.stopFired) {
                                    getErrorsAndShowMessage(
                                        ["from_address"],
                                        {
                                            from_address: null,
                                            error: "Address is invalid"
                                        });
                                    return;
                                }

                                requestBody.push(e("domain") + '=' + e(domainKey));
                                if (getErrorsAndShowMessage(["subject", "company", "question", "from_name", "from_address"], params).length) {
                                    return;
                                }

                                previewConfig.steps[0].requestBody = requestBody;

                                function previewCallback(body) {
                                    // call backend update to save changes
                                    $.ajax({
                                        url: urls['nps:update']()
                                    })

                                    let contentDiv = document.querySelector(".content-wrapper .content");
                                    contentDiv.classList.add("hide");

                                    var iframe = document.querySelector('iframe.nps-email-preview__iframe');

                                    iframe.addEventListener("load", () => {
                                        // replace [First Name] with "John" for preview
                                        let greeting = $("iframe").contents().find(".greeting-message")[0];
                                        if(greeting && greeting.innerText.indexOf("[First Name]") > -1) {
                                            greeting.innerText = greeting.innerText.replace("[First Name]", "John");
                                        }
                                        contentDiv.classList.remove("hide");
                                    })                                    
                                }

                                previewModal.open(previewCallback);

                            });

                            progress.stop();

                        }
                    );

            }
        };
    }
);
